module.exports = __webpack_public_path__ + "static/cake_carrot-1d2c027c646fe1946f3905c54f41ae42.jpg";